import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import styles from './QRCodeModal.module.css';

const QRCodeModal = ({ isOpen, onClose, userKey, linkingCode }) => {
  if (!isOpen) return null;

  // Construct the linking URL with user_key and linking_code
  const linkingUrl = `${window.location.origin}?user_key=${userKey}&linking_code=${linkingCode}`;

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <h2>Link via QR Code</h2>
          <button className={styles.closeButton} onClick={onClose}>
            ×
          </button>
        </div>

        <div className={styles.modalBody}>
          <p className={styles.instructions}>
            Scan this QR code with your other device to link it to your account.
          </p>

          <div className={styles.qrCodeContainer}>
            <QRCodeSVG
              value={linkingUrl}
              size={256}
              level="H"
              includeMargin={true}
            />
          </div>

          <div className={styles.linkInfo}>
            <p className={styles.linkLabel}>Or use these codes manually:</p>
            <div className={styles.codeRow}>
              <span className={styles.codeLabel}>User Key:</span>
              <span className={styles.codeValue}>{userKey}</span>
            </div>
            <div className={styles.codeRow}>
              <span className={styles.codeLabel}>Linking Code:</span>
              <span className={styles.codeValue}>{linkingCode}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QRCodeModal;
